export default {
  home: '主页',
  login: '登录',
  region: '国家/地区',
  mobile: '手机号码',
  smsCode: '验证码',
  backText: '返回',
  sendSmsCode: '获取验证码',
  resendSmsCode: '重获验证码',
  register: '注册',
  submit: '提交',
  required: '必填',
  personalInfo: '个人信息',
  name: '姓名',
  position: '职位',
  note: '备注',
  companyInfo: '公司信息',
  companyTitle: '名称',
  product: '主营产品',
  website: '官网地址',
  address: '地址',
  provinceCity: '省份城市',
  optional: '选填',
  userServicesAgreement: '用户服务协议',
  readAndAgree: '阅读并同意',
  notice: '温馨提示',
  loginWithSms: '短信登录',
  loginWithWechat: '微信登录',
  loginRegister: '未注册艾邦360账号的手机号，登录时将自动注册，且代表您已同意',
  registerError: '注册异常',
  tryLater: '请稍后再试',
  wxAuthError: '微信授权有问题',
  checkAndSubmit: '请检查后再提交',
  inputError: '输入错误',
  proviceCityPlaceholder: '必填',
  mobileError: '手机号码输入有误',
  updatePersonalInfo: '更新个人资料'
}



// WEBPACK FOOTER //
// ./src/lang/zh.js